import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ComponentProps } from 'react';

const FIELD_CLASS =
  'w-full rounded-lg border border-conc-100 bg-sideline px-3 py-2.5 text-[13px] text-navy outline-none transition placeholder:text-conc-300 focus:border-pitch focus:bg-white disabled:opacity-50';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input data-slot="input" className={cn(FIELD_CLASS, className)} {...props} />;
}

/**
 * The header and toolbar search box.
 *
 * The magnifier sits at the inline *start* — visually on the right under `dir="rtl"`,
 * on the left under `dir="ltr"` — using `start-3` and `ps-9` rather than the prototype's
 * hard-coded `right-3 pr-9 pl-3`. Physical insets are the single most common way an RTL
 * layout breaks when `en` is switched on (ADR-013), and there is no reason to inherit
 * that from the prototype when logical properties cost nothing.
 */
export function SearchInput({ className, ...props }: ComponentProps<'input'>) {
  return (
    <div className="relative w-full">
      <Search
        aria-hidden
        className="pointer-events-none absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-conc-300"
      />
      <input
        data-slot="search-input"
        type="search"
        className={cn(FIELD_CLASS, 'ps-9 pe-3', className)}
        {...props}
      />
    </div>
  );
}

export { FIELD_CLASS };
